import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { distinctUntilChanged, Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { NotificationLayout, NotificationTheme } from '@fcom/ui-components';
import { GtmService } from '@fcom/common/gtm';
import { ElementActions, ElementTypes } from '@fcom/common';
import { unsubscribe } from '@fcom/core/utils';
import { RootPaths } from '@fcom/core/constants';
import { GaContext } from '@fcom/common/interfaces/gtm.interface';

import { VoucherService } from '../../services/voucher.service';
import { Voucher, VoucherProductName } from '../../interfaces';

const TRACKING_ELEMENT_NAME = 'expiring-vouchers-notification';

@Component({
  selector: 'fin-expiring-voucher-notification',
  templateUrl: './expiring-voucher-notification.component.html',
})
export class ExpiringVoucherNotificationComponent implements OnInit, OnDestroy {
  readonly VoucherProductName = VoucherProductName;
  readonly ElementTypes = ElementTypes;
  readonly TRACKING_ELEMENT_NAME = TRACKING_ELEMENT_NAME;
  readonly GTM_TRACKING_CONTEXT = GaContext.FINNAIR_PLUS;
  readonly NotificationTheme = NotificationTheme;
  readonly NotificationLayout = NotificationLayout;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  vouchers$: Observable<Voucher[]>;

  oneUpgradeUrl$: Observable<string>;
  expiringVouchers$: Observable<Voucher[]>;
  subscriptions: Subscription = new Subscription();

  constructor(
    private languageService: LanguageService,
    private gtmService: GtmService,
    private voucherService: VoucherService
  ) {
    this.oneUpgradeUrl$ = this.languageService.lang.pipe(map((lang) => `/${lang}/${RootPaths.ONE_UPGRADE_ROOT}`));
  }

  ngOnInit(): void {
    this.expiringVouchers$ = this.vouchers$.pipe(
      map((vouchers) => this.voucherService.expiringTravelClassUpgradeVouchers(vouchers)),
      distinctUntilChanged()
    );
    this.subscriptions.add(
      this.expiringVouchers$.subscribe((vouchers) => {
        if (vouchers.length > 0) {
          this.gtmService.trackElement(
            TRACKING_ELEMENT_NAME,
            GaContext.FINNAIR_PLUS,
            ElementTypes.BANNER,
            'view',
            ElementActions.VIEW
          );
        }
      })
    );
  }

  onCloseNotification(): void {
    this.expiringVouchers$ = of([]);
    this.gtmService.trackElement(
      TRACKING_ELEMENT_NAME,
      GaContext.FINNAIR_PLUS,
      ElementTypes.BANNER,
      'close',
      ElementActions.CLOSE
    );
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
